import { Component, OnInit } from '@angular/core';
import { LpNavbarComponent } from './components/lp-navbar/lp-navbar.component';
import { HeroSectionComponent } from './components/hero-section/hero-section.component';
import { ExperienceSectionComponent } from './components/experience-section/experience-section.component';
import { FeaturesSectionComponent } from './components/features-section/features-section.component';
import { CtaSectionComponent } from './components/cta-section/cta-section.component';
import { LpFooterComponent } from './components/lp-footer/lp-footer.component';
import { FooterBannerComponent } from "../app/footer-banner/footer-banner.component";

@Component({
  selector: 'app-main-landing-page',
  standalone: true,
  imports: [
    LpNavbarComponent,
    HeroSectionComponent,
    ExperienceSectionComponent,
    FeaturesSectionComponent,
    CtaSectionComponent,
    LpFooterComponent,
    FooterBannerComponent
],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.css'
})
export class LandingPageComponent implements OnInit {
  ngOnInit(): void {
    window.scrollTo(0, 0);
  }
}
